import React, { MouseEventHandler } from 'react';

import './Icon.sass';
import { icons } from './utils';

interface IIconProps {
  variant: string;
  className?: string;
  onClick?: MouseEventHandler | undefined;
}

export const Icon: React.FC<IIconProps> = ({ variant, className, onClick }) => {
  return (
    <span onClick={onClick} className={'icon ' + variant + ' ' + className}>
      {icons.filter((icon) => icon.variant === variant)[0]?.code}
    </span>
  );
};
